import { useState } from "react";

const apiUrl = process.env.REACT_APP_API_URL;

/**
 * Custom hook for the main forgot-password flow.
 * Calls POST /auth/forget-password with FormData (same pattern as SuperAdmin ForgotPassword).
 *
 * @returns {{ loading: boolean, error: string, forgotPassword: Function }}
 */
export const useForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /**
   * @param {Object}   param
   * @param {string}   param.email     — User's email address
   * @param {function} param.onSuccess — Called after a successful request
   */
  const forgotPassword = async ({ email, onSuccess }) => {
    setLoading(true);
    setError("");

    const formData = new FormData();
    formData.append("email", email);

    try {
      const response = await fetch(`${apiUrl}/auth/forget-password`, {
        method: "POST",
        body: formData,
      });

      const contentType = response.headers.get("content-type");

      if (!response.ok) {
        const errorText = contentType?.includes("application/json")
          ? (await response.json()).message || "Unknown error occurred"
          : await response.text();
        throw new Error(errorText || `HTTP error! Status: ${response.status}`);
      }

      if (contentType && contentType.includes("application/json")) {
        onSuccess?.();
      } else {
        throw new Error("Unexpected response from server.");
      }
    } catch (err) {
      setError(err.message || "Password reset failed!");
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    setError,
    forgotPassword,
  };
};
